import configs from '../configs/apiConfigs';
import { METHOD_TYPE, CommonApiOptions } from '../constants/api';
import { commonApi } from '../helpers/api';
import { attachHeader } from '../utils/apiHandler';

interface ReviewsParams {
  clinicUniqueId: string;
  startDate: string;
  endDate: string;
}

export const fetchReviewsData = async (params: ReviewsParams) => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}sourcewiseavgcountandratingcount-report/${params.clinicUniqueId}/?startDate=${params.startDate}&endDate=${params.endDate}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    }
  };
  return commonApi(request);
};

export const totalAvgCount = async (params: ReviewsParams) => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}totalavgandcount-report/${params.clinicUniqueId}/?startDate=${params.startDate}&endDate=${params.endDate}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true), 
      withCredentials: true,
    }
  };
  return commonApi(request);
};
